export const BOOKING_TYPES_SELECTION_STORAGE_KEY = 'booking-types-selection'
